<template>
  <div class="__c-label" :class="{ 'margin-bottom': marginBottom }">
    <div class="label">
      <div :class="{ large: large, small: small, lighter: lighter }">
        <slot />
      </div>

      <div class="right-contents" v-if="$slots['right-contents']">
        <slot name="right-contents" />
      </div>
    </div>

    <div class="subtitle" :class="{ small: small }">
      <slot name="subtitle" v-if="$slots.subtitle" />
      <template v-else>{{ subtitle }}</template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CTitle',
  props: {
    subtitle: { type: String },
    marginBottom: { type: Boolean },
    large: { type: Boolean },
    small: { type: Boolean },
    lighter: { type: Boolean },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/mo-custom.scss';
.__c-label {
  &.margin-bottom {
    margin-bottom: $margin-md;
  }

  .label {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    font-size: $font-size-md;
    color: $neutral-color;
    font-weight: 700;

    .right-contents {
      font-weight: normal;
      font-size: $font-size-md;
    }

    .large {
      font-size: $font-size-lg;
    }

    .small {
      font-size: $font-size-sm;
      font-weight: bold;
    }

    .lighter {
      font-weight: normal;
    }

    & > div {
      display: inline-flex;
      align-items: center;
      vertical-align: text-top;
    }
  }

  .subtitle {
    font-size: $font-size-sm;
    color: $neutral-secondary-color;

    &.large {
      font-size: $font-size-md;
    }

    &.small {
      font-size: $font-size-xs;
    }
  }
}
</style>
